import React, { useLayoutEffect, useState } from 'react';
import CardList from 'components/card-list';
import {useQuery} from 'react-query';
import {getOffers} from 'api/offers';
import {IOfferItem} from 'types/offers';
import {QUERY_KEYS} from '../../../constants';
import {useFilterContext} from 'providers/filter-context';
import {useOffersContext} from 'providers/offers-context';
import NoData from 'components/no-data';

const List: React.FC = () => {
  // Get platform filter values from context and check if offers can be fetched
  const {filterType} = useFilterContext();
  const {canFetchList, setOffersList} = useOffersContext();
  const [interceptorReady, setInterceptorReady] = useState(false);

  // Ensure axios interceptor is ready before API calls (fixes toast not showing on first API call)
  useLayoutEffect(() => {
    setInterceptorReady(true);
  }, []);
  
  // Check if any filters are selected
  const hasSelectedFilters = Object.values(filterType).some(value => value);

  // Get filters by platform and made valid query string
  const filters = Object.entries(filterType).reduce<string[]>((acc, [key, value]) => {
    if (value) acc.push(key);
    return acc;
  }, []);

  // Get offers list
  const {data: resultData = [], isFetching} = useQuery<IOfferItem[]>(
    // Query keys for react query cache - On filterType change -  request will be revalidate
    [QUERY_KEYS.OFFERS.LIST, filterType],
    async () => 
      {
      // Fetch offers and cache them in context
      const response = await getOffers({platform: filters, gaid: localStorage.getItem('gaid') || undefined});
      setOffersList(response);
      return response;
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      // Only fetch if we don't have cached data AND at least one filter AND canFetchList is true
      enabled: canFetchList && hasSelectedFilters && interceptorReady, // disable query if no filters selected or if offers list is already fetched
      retry: (failureCount, error: any) => {
        const status = error?.status;
        // Retry once, only if it's NOT one of these status codes
        return failureCount < 1 && ![400, 401, 404].includes(status);
      },
      retryDelay: () => 3000, // 4s delay before the single retry
      staleTime: 120000 // Keep data fresh for 2 minutes (do not allow to refetch offers for same filters for 2 minutes)
    }
  );

  // If no filters are selected, show a message
  if (!hasSelectedFilters) {
    return <NoData message="Please select at least one device type to see offers" />;
  }

  //@ts-ignore
  return <CardList<IOfferItem[]> data={resultData || []} isFetching={isFetching} />;
};

export default List;
